// All icons in one file as separate components
import React from "react";

export const LoginIcon = ({ width = 64, height = 64, strokeColor = "white" }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36 16L28 24H48V40H28L36 48" stroke={strokeColor} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 12H32V52H16" stroke={strokeColor} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M36 16L40 20L36 24" fill={strokeColor}/> {/* Add arrow tip */}
  </svg>
);

export const LogoutIcon = ({ width = 64, height = 64, strokeColor = "white" }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28 16L36 24H16V40H36L28 48" stroke={strokeColor} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M48 12H32V52H48" stroke={strokeColor} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const UserNameIcon = ({ width = 64, height = 64, strokeColor = "white" }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="20" r="10" stroke={strokeColor} strokeWidth="4"/>
    <path d="M16 48C16 38 48 38 48 48V52H16V48Z" stroke={strokeColor} strokeWidth="4"/>
  </svg>
);

export const TextMessageIcon = ({ width = 64, height = 64, strokeColor = "white" }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 12H56V44H32L20 52V44H8V12Z" stroke={strokeColor} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="16" y1="24" x2="48" y2="24" stroke={strokeColor} strokeWidth="4" strokeLinecap="round"/>
    <line x1="16" y1="32" x2="40" y2="32" stroke={strokeColor} strokeWidth="4" strokeLinecap="round"/>
  </svg>
);

export const CalendarIcon = ({ width = 64, height = 64, strokeColor = "white" }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="12" width="48" height="44" rx="4" stroke={strokeColor} strokeWidth="4"/>
    <line x1="8" y1="24" x2="56" y2="24" stroke={strokeColor} strokeWidth="4"/>
    <circle cx="20" cy="36" r="3" fill={strokeColor}/>
    <circle cx="32" cy="36" r="3" fill={strokeColor}/>
    <circle cx="44" cy="36" r="3" fill={strokeColor}/>
  </svg>
);

export const DashboardIcon = ({ width = 64, height = 64, strokeColor = "white" }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="8" width="20" height="20" stroke={strokeColor} strokeWidth="4"/>
    <rect x="36" y="8" width="20" height="12" stroke={strokeColor} strokeWidth="4"/>
    <rect x="8" y="36" width="12" height="20" stroke={strokeColor} strokeWidth="4"/>
    <rect x="28" y="28" width="28" height="28" stroke={strokeColor} strokeWidth="4"/>
  </svg>
);

export const SweatIcon = ({ width = 64, height = 64, strokeColor = "white" }) => (
  <svg width={width} height={height} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 36C20 40 24 44 28 44C32 44 36 40 36 36C36 32 28 20 28 20C28 20 20 32 20 36Z" fill="#06B6D4"/>
    <path d="M40 20C40 24 44 28 48 28C52 28 56 24 56 20C56 16 48 4 48 4C48 4 40 16 40 20Z" fill="#06B6D4"/>
    <path d="M8 28C8 32 12 36 16 36C20 36 24 32 24 28C24 24 16 12 16 12C16 12 8 24 8 28Z" fill="#06B6D4"/>
  </svg>
);


/*

ALl these can be imported with this line:
import { LoginIcon, LogoutIcon, UserNameIcon, TextMessageIcon, CalendarIcon, DashboardIcon, SweatIcon } from './icons';

*/